export default "__VITE_ASSET__6fZHulKn__"